module.exports = __webpack_public_path__ + "3a463aadd1b2a456623aeeadbfb76b92.png";